import amplitude from 'amplitude-js';
import { datadogRum } from '@datadog/browser-rum';
import siteblimp from '@siteblimp/tracking-js';
import { fyiPlatform } from './util';
import { amplitudeKey,  siteblimpKey, sentryRelease, datadogAppId, datadogToken, appVersion } from 'helpers/constants';

const amplitudeClient = amplitude.getInstance();
amplitudeClient.init(amplitudeKey, undefined, { platform: fyiPlatform() });


const siteblimpClient = siteblimp(siteblimpKey);

datadogRum.init({
  applicationId: datadogAppId,
  clientToken: datadogToken,
  site: 'datadoghq.com',
  resourceSampleRate: 25,
  sampleRate: 25,
})
datadogRum.setRumGlobalContext({
  codeVersion: sentryRelease,
  appVersion: appVersion,
})
const datadogClient = datadogRum;

export { amplitudeClient, datadogClient, siteblimpClient };
